"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_my__vodafone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "my-vodafone-hi"), /*#__PURE__*/React.createElement("g", {
    id: "6f22d478-2b9d-4f4e-8129-5c7597823dcb",
    "data-name": "my-vodafone-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "866f6e42-2161-4067-8b7c-d6ab9e6958f4",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15a2c23b-34cf-4d5d-b2be-ae97cc134e52",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4046c9c2-8747-4079-917b-b99001449e74",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "30a9644b-9a26-4022-8900-22a2b18f3979",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "61531154-22fd-4f8e-a0d9-398e61fba06e",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "1630202a-192c-4069-a8a9-0572a26d12c3",
    "data-name": "<Pfad>",
    cx: 96,
    cy: 57.94,
    r: 38.16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2ca7fa1-619f-45ca-903c-57092e202b64",
    "data-name": "<Pfad>",
    d: "M147.85,166.68A12,12,0,0,0,157,151.9c-9.61-38-35.23-55.8-60.66-55.8S44.73,113.84,35,151.86a12,12,0,0,0,9.18,14.82,255.48,255.48,0,0,0,52,5.32A255.48,255.48,0,0,0,147.85,166.68Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.73,95a38.15,38.15,0,0,0,47.43-37c0-.34,0-.67,0-1a38.14,38.14,0,0,1-76.26,0c0,.33,0,.66,0,1A38.17,38.17,0,0,0,86.73,95Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.36,153.92a12,12,0,0,1-9.51,10.76A255.47,255.47,0,0,1,96.13,170a255.48,255.48,0,0,1-52-5.32,12,12,0,0,1-9.51-10.77,12,12,0,0,0,9.51,12.77,255.48,255.48,0,0,0,52,5.32,255.47,255.47,0,0,0,51.72-5.32A12,12,0,0,0,157.36,153.92Z",
    transform: "translate(0 0)"
  })))))))));
}

var _default = ic_my__vodafone;
exports.default = _default;